import { useCmsNew } from "@/lib/cms/cms-new-i18n";
import {
  normalizeSelectionVisibility,
  type SelectionVisibility,
} from "@/lib/cms-puck/blocks/selection";

/**
 * Custom field Puck : bascules « quelles infos afficher sous chaque œuvre »
 * (jeu complet ancien CMS). Valeur = `SelectionVisibility`.
 */

const ROWS: Array<[keyof SelectionVisibility, string]> = [
  ["titles", "Titre"],
  ["authors", "Auteurs"],
  ["dates", "Date"],
  ["techniqueAndSupport", "Technique & support"],
  ["dimensions", "Dimensions"],
  ["signature", "Signature"],
  ["backText", "Inscriptions au dos"],
  ["currentCollection", "Collection actuelle"],
  ["registerNumber", "N° d'enregistrement"],
  // 10ᵉ bascule (parité `visibleCustomField` de l'ancien CMS) : affiche la
  // légende custom saisie PAR ITEM dans le picker de sélection.
  ["customField", "Champ personnalisé (légende par item)"],
];

export function SelectionDisplayField({
  value,
  onChange,
}: {
  value: SelectionVisibility | undefined;
  onChange: (value: SelectionVisibility) => void;
}) {
  const cmsNew = useCmsNew();
  const v = normalizeSelectionVisibility(value);
  return (
    <div className="space-y-1.5 p-1">
      <div className="text-xs font-medium text-slate-600">{cmsNew("cms.new.auto.text.infos_affichees", "Infos affichées")}</div>
      <div className="grid grid-cols-1 gap-1">
        {ROWS.map(([key, label]) => (
          <label
            key={key}
            className="flex items-center justify-between gap-3 rounded px-2 py-1 text-sm text-slate-700 hover:bg-slate-50"
          >
            {cmsNew(`cms.new.fields.selectionDisplay.${key}`, label)}
            <input
              type="checkbox"
              checked={v[key]}
              onChange={(e) => onChange({ ...v, [key]: e.target.checked })}
              className="h-4 w-4 accent-slate-900"
            />
          </label>
        ))}
      </div>
    </div>
  );
}
